import { useMemo } from 'react'

import { useSession } from '@rewardops/auth'

import { NavigationLink } from '~/context/resources-provider'

const useNavigationLinks = ({
  direct,
  menu,
}: {
  direct: NavigationLink[] | undefined
  menu:
    | {
        id: string
        name: string
        links: NavigationLink[]
      }[]
    | undefined
}) => {
  const { data: session } = useSession()

  const { directLinks, menuLinks } = useMemo(() => {
    const filterLinks = (links: NavigationLink[] | undefined) =>
      links?.filter((link) => {
        if (!session && link?.requiresLogin === true) {
          return false
        }
        return true
      })

    return {
      directLinks: filterLinks(direct),
      menuLinks: menu
        ?.map((menuLink) => ({
          ...menuLink,
          links: filterLinks(menuLink.links),
        }))
        ?.filter((menuLink) => menuLink?.links?.length),
    }
  }, [direct, menu, session])

  return { directLinks, menuLinks }
}

export { useNavigationLinks }
